import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { SuccessBody } from '../../model/success_body';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  body : SuccessBody = new SuccessBody;

  constructor(private element : ElementRef, private modalService : ModalService) {
    this.body.list_content = [];
   }

  ngOnInit() {
    console.log(this.body);
  }

  show(body : SuccessBody = new SuccessBody){

    this.body = { 
      current_icon : "./assets/img/modal_v2/e-info.png",
      text_align: "text-center",
      list_space: "mb-1",
      list_content: [], ...body 
    };
    this.element.nativeElement.style.visibility = "visible";
  }

  hide(){
    this.element.nativeElement.style.visibility = "hidden";
    if (this.body.onSecondaryAction) this.body.onSecondaryAction();
  }

  hideBack(){
    this.element.nativeElement.style.visibility = "hidden";
  }

  accept(){
    this.element.nativeElement.style.visibility = "hidden";
    if(this.body.onMainAction) this.body.onMainAction();
  }

  link(){
    this.element.nativeElement.style.visibility = "hidden";
    if(this.body.onLinkAction) this.body.onLinkAction();
  }
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/modals/success/success.component.ts